export const apikey = "d687412e7b53146b2631dc01974ad0a4";
export const store = {
	userd: {
		people: [{name: "You", age: 22, sex: "F"}],
		zip: "33134",
		people_num:1,
		income: 40000,
	}
}